import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const WhyChoose: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const features = [
    {
      title: '100% Screen-Free Ground Floor',
      description: 'Unlike other schools, our main learning areas are completely free from digital distractions',
      color: 'brand-yellow',
    },
    {
      title: 'Research-Based Approach',
      description: 'Following AAP guidelines and child development research for optimal learning outcomes',
      color: 'brand-blue',
    },
    {
      title: 'Comprehensive Sensory Kit',
      description: 'Extensive collection of hands-on learning materials for multi-sensory development',
      color: 'brand-pink',
    },
    {
      title: 'Individual Attention',
      description: 'Small class sizes ensure each child receives personalized care and attention',
      color: 'brand-green',
    },
    {
      title: 'Natural Learning Materials',
      description: 'Taste-safe, eco-friendly materials that are completely safe for young children',
      color: 'brand-yellow',
    },
    {
      title: 'Holistic Development',
      description: 'Focus on physical, cognitive, social, and emotional development through play',
      color: 'brand-blue',
    },
  ];

  return (
    <section className="why-choose p-16 bg-brand-light">
      <div className="container">
        <motion.div
          ref={ref}
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className='text-3xl font-bold text-brand-pink mb-8'>Why Choose Neev Play School?</div>
          <div className='text-lg text-brand-purple mb-8'>What makes us different from other preschools</div>
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className={`card relative overflow-hidden group py-6 px-16 bg-${feature.color} bg-opacity-10 border-2 border-${feature.color} rounded-3xl`}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -8, boxShadow: '0 15px 35px rgba(224, 58, 138, 0.10)' }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-brand-pink/5 to-brand-blue/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-3xl" />
              <div className="relative z-10">
                <h4 className={`text-xl font-semibold text-${feature.color} mb-3`}>
                  {feature.title}
                </h4>
                <p className="text-brand-dark leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Additional CTA
        <motion.div
          className="text-center mt-12"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <div className="bg-primary/5 border border-primary/20 rounded-lg p-8 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-text-primary mb-4">
              Ready to Give Your Child the Best Start?
            </h3>
            <p className="text-text-secondary mb-6">
              Join our community of families who believe in the power of hands-on, screen-free learning. 
              Contact us today to schedule a visit and see our approach in action.
            </p>
            <motion.a
              href="#contact"
              className="btn btn--primary"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              Schedule a Visit
            </motion.a>
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default WhyChoose; 